import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const constructionReportList = createAsyncThunk('constructionReportList', async ({ pageable, navigate }) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'construction-project/report-history',
            params: {
                pageSize: pageable?.pageSize,
                pageNo: pageable?.currentPage,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": SessionManager.getCookie("user_token"),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const constructionReportListSlice = createSlice({
    name: 'constructionReportList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(constructionReportList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const responseData = action?.payload?.data
                const payloadData = responseData?.data ?? responseData
                state.data = Array.isArray(payloadData) ? payloadData : []
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(constructionReportList.rejected, (state) => {
            state.data = []
        })
    }
})

export default constructionReportListSlice.reducer;
